import React from 'react'

function Bell ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='24' height='24' viewBox='0 0 24 24'>
      <path d='M161.159,387.429A3.542,3.542,0,0,1,157.6,384h1.143a2.418,2.418,0,0,0,4.829,0h1.143A3.542,3.542,0,0,1,161.159,387.429Zm0,0' transform='translate(-149.159 -363.429)' />
      <path d='M38.286,21.143c-2.486,0-3.143-7.85-3.143-12a8,8,0,1,0-16,0c0,4.15-.657,12-3.143,12V20c.6,0,2-3.693,2-10.857a9.143,9.143,0,0,1,18.286,0c0,7.164,1.4,10.857,2,10.857Zm0,0' transform='translate(-15.143)' />
      <path d='M0,373.332H24v1.143H0Zm0,0' transform='translate(0 -353.332)' />
    </svg>
  )
}

Bell.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Bell
